// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3DIam","requiredAsterisk":"Info_requiredAsterisk__3l0F4"};